import { IResponseDetailMaterial } from '@/interfaces/doccen-lib/contentManagement.interface';
import { ILastestSubscriptionPlanResponse } from '@/interfaces/subscription.interface';
import { PropsWithChildren, createContext } from 'react';
import { UseMutationResult } from 'react-query';

export interface IDocumentDetailContext {
  document: IResponseDetailMaterial | undefined;
  mutationResult: UseMutationResult<
    { conversationId: string },
    any,
    void,
    unknown
  >;
  toggleModalUpgradePlan: () => void;
  latestSubscription: ILastestSubscriptionPlanResponse | undefined;
}

export const DocumentDetailContext = createContext<IDocumentDetailContext>({
  document: undefined,
  mutationResult: {} as UseMutationResult<
    { conversationId: string },
    any,
    void,
    unknown
  >,
  toggleModalUpgradePlan: () => {},
  latestSubscription: undefined,
});

const DocumentDetailProvider = ({
  children,
  ...props
}: PropsWithChildren<IDocumentDetailContext>) => {
  return (
    <DocumentDetailContext.Provider value={props}>
      {children}
    </DocumentDetailContext.Provider>
  );
};

export default DocumentDetailProvider;
